import React from 'react';
import QuoteBuilderForm from 'components/layout_and_quote_builder/quote_builder/QuoteBuilderForm.jsx';

// İç sıvama (inside lamination) material price. A thin section component (like LacquerCoating.jsx) pointing at the
// inside_lamination_material config; the inherited board layout is injected into props.options server-side.
const InsideLaminationMaterial = (props) => (
  <QuoteBuilderForm
    config={props.config.inside_lamination_material}
    disabled={props.disabled}
    disabledReason={props.disabledReason}
    options={props.options}
    section_uuid={props.uuid}
    navSectionColumnType={props.navSectionColumnType}
    item={props.item}
    extra_title={props.extra_item_title}
    navSection={props.navSection}
    columnTitle={props.columnTitle}
    colIndex={props.colIndex}
    rowIndex={props.rowIndex}
    getExtraItems={props.getExtraItems}
    readOnly={window.user_quote_finalised}
  />
);

export default InsideLaminationMaterial;
